export default __webpack_public_path__ + "static/media/opengl-house.3ea8ca16.png";